import { ArrowLeft, PawPrint } from 'lucide-react';
import { Link } from 'react-router-dom';

interface NotFoundPageProps {
  /** Which app are we in. Determines back-link destination + footer copy. */
  context?: 'staff' | 'customer';
}

export function NotFoundPage({ context = 'staff' }: NotFoundPageProps) {
  const dashboardPath = context === 'staff' ? '/today' : '/account';
  const homeLabel = context === 'staff' ? 'Back to dashboard' : 'Back to your account';

  return (
    <main className="grid min-h-[100dvh] place-items-center bg-background px-6 py-12 text-foreground">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-8 grid size-16 place-items-center rounded-2xl bg-primary text-primary-foreground">
          <PawPrint className="size-7" strokeWidth={1.75} />
        </div>
        <p className="num font-heading text-6xl font-medium tracking-tight">404</p>
        <h1 className="mt-3 font-heading text-2xl font-medium tracking-tight">Page not found</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          We can&apos;t find what you&apos;re looking for. The link might be broken or the page may
          have moved.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={dashboardPath}
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground press hover:bg-primary/90"
          >
            <ArrowLeft className="size-4" strokeWidth={1.75} />
            {homeLabel}
          </Link>
          {context === 'staff' && (
            <Link
              to="/customers"
              className="text-sm text-muted-foreground underline-offset-2 hover:underline"
            >
              View customers
            </Link>
          )}
        </div>
      </div>
    </main>
  );
}
